import { render } from "./index.vue?vue&type=template&id=6ab74eaa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ab74eaa&scoped=true&lang=css"

import exportComponent from "C:\\Desenvolvimento\\projetos\\web\\cliqx.checkout.frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab74eaa"]])

export default __exports__